<div class="landing-glow absolute inset-0" [attr.data-variant]="variant()" aria-hidden="true">
    <span class="landing-glow-blob landing-glow-blob--one"></span>
    <span class="landing-glow-blob landing-glow-blob--two"></span>
    <span class="landing-glow-blob landing-glow-blob--three"></span>
</div>
